






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {ConfigAlerta} from '@/model/resource/ConfigAlerta'
import {InputConfigAlertaSchema} from '@/schema/resource/ConfigAlerta/InputConfigAlertaSchema'

@Component
export default class PersistConfigAlertaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputConfigAlertaSchema()
  configAlerta = new ConfigAlerta()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.configAlerta.getConfigAlerta(id)
    }

    $.await.done('getConfigAlerta')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.configAlerta.persistConfigAlerta()
    await Helper.successAndPush('system.success.persist', '/config-alerta/list')
  }
}
